/** Checks the visible text and any extra `searchText` separately, so a query
 *  cannot match by straddling the join between them. */
export const matchesOptionSearch = (
  query: string,
  text: string | number | undefined,
  searchText?: string
): boolean => {
  const needle = query.trim().toLowerCase()
  if (!needle) return true
  return (
    String(text ?? '')
      .toLowerCase()
      .includes(needle) || (searchText ?? '').toLowerCase().includes(needle)
  )
}
